import Modal from 'bootstrap/js/dist/modal'

const elements = document.getElementsByClassName('notification-modal')

for (const element of elements) {
  const modal = new Modal(element, {})
  modal.show()
}
